module.exports = {
  "country": "UK",
  "artist": "Katrina and the Waves",
  "song": "Love Shine a Light",
  "year": "1997",
  "place": "1",
  "spotify": "7jxGRU3EH0QveYx4bD32i7"
};